import React, {useState} from 'react';
import {isEmail, setElementAttribute} from "../utils/common-utils.ts";
import ReactDOM from "react-dom/client";
import {renderTextField, renderTextArea, renderEmailField, renderDropdown} from "./fields/FormFields.tsx";

export const renderFormContactEn = (div: string) => {
    {
        const root = document.getElementById(div)
        if (root) {
            ReactDOM.createRoot(root).render(<React.StrictMode><FormContactEn/></React.StrictMode>)
        }
    }
}
const FormContactEn = () => {
    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [commentOn, setCommentOn] = useState('select');
    const [commentDetails, setCommentDetails] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const renderName = () => {
        const inputData = {
            name: 'Your name',
            id: 'name',
            label: 'Name',
            type: 'text',
            autoComplete: 'name',
            value: '',
            inputMode: 'text',
            required: true,
            description: 'field_description_name',
            message: 'Your name is required. Please enter your name.',
            errorMessageID: 'name_error_message',
            visible: false
        }
        return renderTextField(inputData, name, setName, submitted);
    }

    const renderCity = () => {
        const inputData = {
            name: 'your city',
            id: 'location',
            label: 'Your City',
            type: 'text',
            autoComplete: 'address-level2',
            inputMode: 'text',
            value: '',
            required: true,
            description: 'field_description_city',
            message: 'Your location is required. Please enter your city name.',
            errorMessageID: 'city_error_message',
            visible: false
        }
        return renderTextField(inputData, city, setCity, submitted);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            label: 'Email',
            type: 'email',
            required: true,
            description: 'field_description_email',
            message: 'Your email address is required. Please provide a valid email address.',
            errorMessageID: 'email_error_message',
            visible: true,
            success: 'Thank You for your email address.'
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress, submitted);
    }

    const renderPhoneDetails = () => {
        const inputData = {
            name: 'phone number',
            label: 'Phone',
            id: 'phoneNumber',
            type: 'tel',
            inputMode: 'tel',
            value: '',
            required: false,
            autoComplete: 'tel-national',
            description: 'field_description_phone',
            message: 'Your phone number is optional.',
            errorMessageID: '',
            visible: false
        }
        return renderTextField(inputData, phone, setPhone, submitted);
    }

    const renderCommentChoices = () => {
        const inputData = {
            id: 'commentChoice',
            name: 'Comment on',
            label: 'Comment on',
            option: [
                {label: '- Select -', value: 'select'},
                {label: 'General', value: 'General'},
                {label: 'Website', value: 'Website'},
                {label: 'Video Archives', value: 'Video Archives'},
                {label: 'CPAC Programs', value: 'CPAC Programs'},
                {label: 'Careers', value: 'Careers'},
                {label: 'CPAC in Your Area', value: 'CPAC in Your Area'},
                {label: 'Order a Video', value: 'Order a Video'},
                {label: 'Social Media', value: 'Social Media'},
            ],
            required: true,
            description: 'field_description_select',
            message: 'Please select a comment topic.',
            errorMessageID: 'comment_choice_error_message',
            visible: false
        };

        return renderDropdown(inputData, commentOn, setCommentOn, submitted);
    }

    const renderComments = () => {
        const inputData = {
            name: 'your comments',
            id: 'comments',
            label: 'Comments',
            inputMode: 'text',
            description: 'field_description_comments',
            message: 'Please provide any comments or questions.',
            errorMessageID: 'comments_error_message',
            required: true,
            visible: false
        }
        return renderTextArea(inputData, commentDetails, setCommentDetails, submitted);
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const hasErrors = !name || !city || !emailAddress || !isEmail(emailAddress) || !commentDetails || !commentOn || commentOn === 'select' || commentOn === '' ? true : false;
        setSubmitted(true);
        const mailSubject = "?subject=Submission from Contact Form English";
        const mailBody = `&body=Name: ${name}%0D%0ACity: ${city}%0D%0AEmail Address: ${emailAddress}%0D%0APhone: ${phone}%0D%0ACommenting On: ${commentOn}%0D%0AComments: ${commentDetails}` ;
        const sendMail = "mailto:comments@cpac.ca";
        const errorMessages = document.querySelector("#error_summary") as HTMLElement | null;
        if (hasErrors) {    
                setElementAttribute("error_summary", "aria-labelledby", "error_summary_heading");
                document.getElementById("error_summary")?.focus();
        } else {
            window.open(sendMail + mailSubject + mailBody);
            e.target.reset();
            setName('');
            setCity('');
            setEmailAddress('');
            setPhone('');
            setCommentOn('select');
            setCommentDetails('');
            setSubmitted(false);
            errorMessages?.removeAttribute("aria-labelledby");
        }
    }

    return (
        <>
            {
                <div id="form_wrapper" className="form_wrapper" itemScope itemType="https://schema.org/ContactPage">
                    <div id='error_summary' aria-live="assertive" tabIndex={-1}>
                        {submitted && (!name || !city || !emailAddress || !isEmail(emailAddress) || !commentDetails || !commentOn || commentOn === 'select' || commentOn === '') ? <h2 id='error_summary_heading' role='alert' className='error_message invalid'>There are errors in the form.<br/><span>Please correct the errors and re-submit.</span></h2> : null}
                        <ul className="reg-list">
                        {submitted && !name ? <li id="name_error_message" className='error_message invalid'><a href="#name"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please enter your name.</a></li> : null}
                        {submitted && !city ? <li id="city_error_message" className='error_message invalid'><a href="#location"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please enter your city name.</a></li> : null}
                        {submitted && !isEmail(emailAddress) ? <li id="email_error_message" className='error_message invalid'><a href="#emailAddress"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please enter a valid email address.</a></li> : null}
                        {submitted && (!commentOn || commentOn === 'select' || commentOn === '') ? <li id="comment_choice_error_message" className='error_message invalid'><a href="#commentChoice"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please select a comment topic.</a></li> : null}
                        {submitted && !commentDetails ? <li id="comments_error_message" className='error_message invalid'><a href="#comments"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please provide your comments.</a></li> : null}
                        </ul>
                    </div>
                    <form aria-label="Contact Form" id="contact-form" onSubmit={(e) => handleSubmit(e)} itemScope itemType="https://schema.org/WebPageElement" noValidate>
                        <div className="form_body" itemProp='mainEntityOfPage'>
                            {renderName()}
                            {renderCity()}
                            {renderEmailDetails()}
                            {renderPhoneDetails()}
                            {renderCommentChoices()}
                            {renderComments()}
                        </div>
                        <div className='form_footer left_label'>
                            <button type="submit" className="btn--primary">Send by Email</button>
                        </div>
                    </form>
                </div>
            }
        </>
    )
}

export default FormContactEn;